const translations = {
    description: 'Select the application map or flight export',
    title: 'Export as Applied Map'
};

export default translations;
